import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { operatorColors } from '~/utils/operatorColors';

import { SubNodes } from '~/components/CustomNodes';

// Componente para renderizar variáveis com estilo especial
const VariableChip = ({ variableName, onRemove }) => (
    <div style={{
        background: '#e0f7fa',
        borderRadius: '12px',
        padding: '4px 8px',
        margin: '0 2px',
        display: 'inline-flex',
        alignItems: 'center',
        color: '#006064',
        fontWeight: '500',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        userSelect: 'none'
    }}>
        <span>{variableName}</span>
        <button
            onClick={(e) => {
                e.stopPropagation();
                onRemove();
            }}
            style={{
                background: 'none',
                border: 'none',
                marginLeft: '6px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#006064',
                borderRadius: '50%',
                width: '14px',
                height: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(0, 96, 100, 0.1)'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
        >
            ×
        </button>
    </div>
);

// Controlled input/drop area: accepts drops of operator nodes or simple values
export const CustomInputDrop = ({ dropData, dropId, onDropChange, style }) => {
    // Handle drop de operador OU variável
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Primeiro tenta operador
        const operatorType = e.dataTransfer.getData('application/reactflow');
        if (operatorType) {
            const newDrop = { id: dropId, type: operatorType, data: {} };
            onDropChange?.(newDrop);
            return;
        }
        // Depois tenta variável
        const varData = e.dataTransfer.getData('application/variavel');
        if (varData) {
            try {
                const v = JSON.parse(varData);
                onDropChange?.({ id: dropId, type: null, data: { value: `{{${v.nome}}}`, isVariable: true, variableName: v.nome } });
            } catch (error) {
                console.error('Error parsing variable data:', error);
            }
        }
    };
    const handleDragOver = (e) => e.preventDefault();
    
    // Handle typing a simple value
    const handleInputChange = (e) => {
        const newVal = e.target.value;
        onDropChange?.({ ...dropData, data: { ...dropData.data, value: newVal, isVariable: false, variableName: null } });
    };
    
    // Handle nested operator data changes
    const onSubDataChange = (newSubData) => {
        onDropChange?.({ ...dropData, data: { ...dropData.data, ...newSubData } });
    };

    const toggleLayout = (e) => {
        e.stopPropagation();
        const current = dropData?.data?.layout || 'vertical';
        const next = current === 'vertical' ? 'horizontal' : 'vertical';
        onSubDataChange({ layout: next });
    };
    
    // Handle variable removal
    const handleRemoveVariable = () => {
        onDropChange?.({ id: dropId, type: null, data: {} });
    };
    
    // Render nested operator component or input
    const OperatorComponent = dropData?.type && SubNodes[dropData.type];
    const borderColor = operatorColors[dropData.type] || 'gray';
    const backgroundColor = dropData.type ? `${borderColor}20` : 'transparent';
    
    // Se é uma variável, mostra o chip especial
    if (dropData?.data?.isVariable && dropData?.data?.variableName) {
        return (
            <div
                onDrop={handleDrop} onDragOver={handleDragOver}
                className="custom-input-drop-wrapper"
                style={{
                    display: 'flex', alignItems: 'center', gap: '4px',
                    minWidth: '80px', maxWidth: dropData?.type ? '100%' : '200px', border: `2px dashed ${borderColor}`,
                    padding: '4px', borderRadius: '4px', backgroundColor,
                    minHeight: '30px', flexShrink: 1
                    , ...style
                }}
            >
                <VariableChip 
                    variableName={dropData.data.variableName}
                    onRemove={handleRemoveVariable}
                />
            </div>
        );
    }
    
    return (
        <div
            onDrop={handleDrop} onDragOver={handleDragOver}
            className="custom-input-drop-wrapper"
            style={{
                display: 'flex', alignItems: 'center', gap: '4px',
                minWidth: '80px', maxWidth: dropData?.type ? '100%' : '200px', border: `2px dashed ${borderColor}`,
                padding: '4px', borderRadius: '4px', backgroundColor,
                flexShrink: 1
                , ...style
            }}
        >
            {OperatorComponent
                ? <div style={{ flex: 1, minWidth: 0 }}><OperatorComponent data={dropData.data} notNode onDataChange={onSubDataChange} /></div>
                : <input 
                    type="text" 
                    value={dropData.data.value || ''} 
                    onChange={handleInputChange} 
                    placeholder="Valor" 
                    style={{ 
                        flex: 1, 
                        marginRight: '4px',
                        border: 'none',
                        outline: 'none',
                        background: 'transparent',
                        fontSize: '13px',
                        minWidth: '40px'
                    }} 
                />
            }
            {(dropData.type || dropData.data.value) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                    {dropData.type && (
                        <button
                            title={`Alternar layout (${dropData?.data?.layout === 'vertical' ? 'vertical' : 'horizontal'})`}
                            onClick={toggleLayout}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '2px',
                                fontSize: '12px'
                            }}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                    )}
                    <button
                        title="Remover"
                        onClick={() => onDropChange({ id: dropId, type: null, data: {} })}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '2px',
                            fontSize: '12px'
                        }}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-trash-can" />
                    </button>
                </div>
            )}
        </div>
    );
};